import { GridRenderCellParams, GridTreeNodeWithRender } from "@mui/x-data-grid";
import { CopyToClipboardButton } from "../../components/CopyToClipboardButton/CopyToClipboardButton";
export const LINK_TABLE_COLUMNS = [
    {
        field: 'displayName',
        headerName: 'Name',
        width: 200,
        renderCell: (params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>) => (
            <span>{params.row.displayName}</span> 
        ),
    },
    {
        field: 'url',
        headerName: 'URL',
        width: 300,
        minWidth: 100,
        renderCell: (params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>) => (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginRight: 8 }}>
              {params.row.url}
            </span>
            <CopyToClipboardButton text={params.row.url}/>
          </div>
        ),
      },
    {
        field: 'bundle',
        headerName: 'Bundle',
        width: 100,
        renderCell: (params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>) => (
            <span>{params.row.bundleName || 'N/A'}</span>
        ),
    },
    {
        field: 'product',
        headerName: 'Product',
        width: 100,
        renderCell: (params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>) => (
            <span>{params.row.product || 'N/A'}</span>
        ),
    },
];